import { render, staticRenderFns } from "./DashboardGreeting.vue?vue&type=template&id=4decafa2&"
import script from "./DashboardGreeting.vue?vue&type=script&lang=js&"
export * from "./DashboardGreeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports